import { render, staticRenderFns } from "./RelatedModules.vue?vue&type=template&id=049e1f61"
import script from "./RelatedModules.vue?vue&type=script&lang=js"
export * from "./RelatedModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports